// src/components/Preloader.js
import React, { useState, useEffect } from "react";

function Preloader() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simula que la página terminó de cargar
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null;

  return (
    <div id="preloader">
      <div id="status">&nbsp;</div>
    </div>
  );
}

export default Preloader;